<template>
  <div class="widget border-0">
    <div class="header border-0">
      <div class="title border-0">
        {{ __(title) }}<span class="total ml-1">({{ getTotal() | number(0) }})</span>
      </div>
    </div>
    <div
      class="body mt-4 border-0"
      v-if="loading"
    >
      <span class="loading"><i class="fa fa-circle-o-notch fa-spin" /></span>
    </div>
    <div
      :class="list.length === 0 ? 'body border-0 h-100' : 'body mt-4 border-0'" style="min-height:300px;"
      v-else
    >
      <div v-if="list.length === 0" class="h-100 d-flex flex-column justify-content-center align-items-center">
        <h2 style="font-weight: 700;font-size: 1.375rem;text-align: center;">
          {{ __('Nenhum dado foi encontrado neste período!') }}
        </h2>
        <h3 style="font-size: 1.125rem;font-weight: 400;text-align: center;">
          {{ __('Já tentou alterar as datas?') }}
        </h3>
      </div>

      <div v-else>
        <div
          class="activity border-0"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="media">
            <div class="item">
              <span class="activity-name mr-1">{{ __(getActivityName(index)) | truncate('20') }}</span><span class="activity-total f-w-700 ml-1">{{ list[index].total | number(0) }}</span>
            </div>
            <div class="ml-auto">
              <div
                class="text-salesflow-font-gray f-w-500"
                v-b-tooltip.left="periodTooltipText()"
              >
                <span>{{ getActivityStats(index) | number(0) }}</span><span class="trend float-right"><i :class="icon(getActivityStats(index))" /></span>
              </div>
            </div>
          </div>
          <div class="progress border-0">
            <div
              class="progress-bar"
              role="progressbar"
              aria-valuemin="0"
              aria-valuemax="100"
              :aria-valuenow="getProgress(index)"
              :style="'width: ' + getProgress(index) + '%'"
              :class="color"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';
import progresWidget from '../../mixins/progress-widget';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },

  mixins: [progresWidget],

  props: ['name'],

  computed: {
    title () {
      const title = {
        'activity.started': 'iniciadas',
        'activity.completed': 'finalizadas',
        'activity.scheduled': 'a finalizar',
        'activity.successful': 'finalizadas com sucesso',
        'activity.unsuccessful': 'finalizadas sem sucesso',
        'activity.deleted': 'excluídas',
      };

      return this.__(`Atividades ${title[this.name]}`);
    },

    color () {
      const className = {
        'activity.started': 'background-gradient-purple',
        'activity.completed': 'background-gradient-green',
        'activity.scheduled': 'background-gradient-pink',
      };

      return className[this.name];
    },
  },

  methods: {
    icon (trend = 0) {
      if (trend < 0) {
        return 'fa fa-angle-down color-salesflow-danger-hover';
      }

      return 'fa fa-angle-up color-salesflow-secondary';
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../sass/variables';
  @import '../../../sass/mixins';

  span.total {
    font-weight: 400;
  }

  .activity {
    .media {
      margin-bottom: 0.5rem;
    }

    &:last-child .progress {
      margin-bottom: 0px !important;
    }
  }

  span.activity-name {
    @include salesflow-subtitle($color: $salesflow-font-dark, $font-weight: 500);
  }
  span.activity-total {
    @include salesflow-subtitle($color: $salesflow-font-dark, $font-weight: 700);
  }
</style>
